import React from 'react';
import { Icon } from 'antd';

class ProjectHeader extends React.Component {
  state = {
    headerColor: null
  };

  getCircleStyle = index => {
    const { current, editing } = this.props.status;
    let editingPhase = index == editing ? true : false;
    let color;
    if (current < index) {
      color = '#626262'; //Gray
    } else if (index == current) {
      color = '#E19F48'; //Orange
    } else if (current == 6) {
      color = '#52B397'; //Green
    } else {
      color = '#52B397';
    }

    if (editingPhase) {
      return {
        height: 80,
        width: 50,
        border: '3px solid white',
        backgroundColor: color,
        color: 'white',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 20,
        marginTop: -27,
        borderTop: 'none',
        borderBottomLeftRadius: 30,
        borderBottomRightRadius: 30,
        paddingTop: 30,
        cursor: 'pointer'
      };
    } else {
      return {
        height: 50,
        width: 50,
        borderRadius: '50%',
        border: '3px solid white',
        borderTop: '3px solid white',
        backgroundColor: color,
        color: 'white',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 20,
        cursor: 'pointer'
      };
    }
  };

  render() {
    let backgroundColor;
    let { current, editing } = this.props.status;
    if (editing > current) {
      backgroundColor = '#626262';
    } else if (editing == current) {
      backgroundColor = '#E19F48';
    } else {
      backgroundColor = '#52B397';
    }

    const styles = {
      container: {
        width: '100%',
        height: 85,
        borderBottom: '3px solid white',
        position: 'absolute',
        top: 77,
        backgroundColor: backgroundColor,
        zIndex: 1
      },
      title: {
        fontFamily: 'Arial Rounded MT Bold',
        fontSize: 18,
        marginTop: 10,
        color: 'white'
      }
    };

    return (
      <div style={styles.container}>
        <div style={{ width: 650, margin: '0 auto' }}>
          <Icon
            onClick={() => this.props.close()}
            style={{
              position: 'relative',
              right: 0,
              top: 10,
              float: 'right',
              fontSize: 20,
              color: 'white',
              cursor: 'pointer'
            }}
            type="close"
          />
          <h3 style={styles.title}>{this.props.title}</h3>
          <h3 style={styles.title}>
            {this.props.phase && this.props.phase.toUpperCase()}
          </h3>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: 450,
            margin: '0 auto',
            marginTop: 35
          }}>
          <div
            onClick={() => this.props.changeEditing(1)}
            style={this.getCircleStyle(1)}>
            1
          </div>
          <div
            onClick={() => this.props.changeEditing(2)}
            style={this.getCircleStyle(2)}>
            2
          </div>
          <div
            onClick={() => this.props.changeEditing(3)}
            style={this.getCircleStyle(3)}>
            3
          </div>
          <div
            onClick={() => this.props.changeEditing(4)}
            style={this.getCircleStyle(4)}>
            4
          </div>
          <div
            onClick={() => this.props.changeEditing(5)}
            style={this.getCircleStyle(5)}>
            5
          </div>
        </div>
      </div>
    );
  }
}

export default ProjectHeader;



// WEBPACK FOOTER //
// ./src/containers/StudentApp/components/projectHeader.js